import types from './types';

const InitialState = {
    opened: false,

    loaded: false,
    has_unread: false,
    notifications: [],
    notifications_count: 0
}

export default (state = InitialState, {type, payload}) => {
    switch(type) {
        case types.mark_as_read:
            return {
                ...state,
                notifications: state.notifications.map(notification => {
                    return !notification.is_read ? {
                        ...notification,
                        is_read: payload.includes(notification.id)
                    } : notification;
                }),
                has_unread: state.notifications.filter(n => n.is_read === false && !payload.includes(n.id)).length > 0
            }
        case types.remove_notification:
            return {
                ...state,
                notifications: state.notifications.filter(notification => notification.id !== payload)
            }
        case types.toggle_notification:
            return {
                ...state,
                notifications: state.notifications.map(notification => {
                    return notification.id === payload ? {
                        ...notification,
                        disabled: !notification.disabled
                    } : notification;
                })
            }
        case types.new_notification:
            return {
                ...state,
                has_unread: true,
                notifications: [
                    {
                        ...payload,
                        timestamp: Date.now() + payload.timestamp,
                        disabled: false
                    },
                    ...state.notifications
                ],
                notifications_count: state.notifications_count + 1
            }
        case types.loaded:
            return {
                ...state,
                loaded: true,
                has_unread: payload.has_unread,
                notifications: payload.notifications.map(notification => {
                    return {
                        ...notification,
                        timestamp: notification.timestamp + Date.now(),
                        disabled: false
                    }
                }),
                notifications_count: payload.notifications_count
            }
        case types.toggle:
            return {
                ...state,
                opened: !state.opened
            }
        default:
            return state;
    }
}